const TRANSLIT: Record<string, string> = {
  а: "a", б: "b", в: "v", г: "g", д: "d", е: "e", ё: "e",
  ж: "zh", з: "z", и: "i", й: "y", к: "k", л: "l", м: "m",
  н: "n", о: "o", п: "p", р: "r", с: "s", т: "t", у: "u",
  ф: "f", х: "kh", ц: "ts", ч: "ch", ш: "sh", щ: "shch",
  ъ: "", ы: "y", ь: "", э: "e", ю: "yu", я: "ya",
};

function transliterate(text: string): string {
  let out = "";
  for (const c of text.toLowerCase()) {
    out += TRANSLIT[c] ?? c;
  }
  return out.replace(/[^a-z0-9]/g, "");
}

// Same formula as the mobile app (bc-vikings-app, admin_players_page.dart
// _generateCredentials) — change both places together.
export function generateCredentials(
  surname: string,
  name: string
): { login: string; password: string } | null {
  const s = transliterate(surname.trim());
  const n = transliterate(name.trim());
  if (!s || !n) return null;
  return {
    login: `${s}_${n}`,
    password: `${s[0].toUpperCase()}${n}${((s.length * 7 + n.length * 13) % 90) + 10}!`,
  };
}
